export const SET_NOTICE = "SET_NOTICE";
export const GET_NOTICE = "GET_NOTICE";
export const DELETE_NOTICE = "DELETE_NOTICE";
export const UPDATE_NOTICE = "UPDATE_NOTICE";
export const GET_ONE_NOTICE = "GET_ONE_NOTICE";
export const DELETE_IMAGE = "DELETE_IMAGE";
export const ADD_PHOTOS = "ADD_PHOTOS";